Dates = require 'lib/dates'
Util = require 'lib/util'
View = require 'view'
moment = require 'moment'
template = require 'views/templates/header_warning_account_transfer_required'

module.exports = class AccountTransferRequiredBannerView extends View
  BANNER_MESSAGE_NAME = "AccountTransferRequired"

  className: 'header-banner'

  constructor: ({ enterprise }) ->
    super
    @enterprise = enterprise

  events:
    'click .js-dismiss-account-transfer': 'dismiss'

  dismiss: (e) ->
    Util.stop(e)
    @model.dismiss BANNER_MESSAGE_NAME, =>
      @remove()

  _remainingDays: ->
    targetDate = Dates.parse(@enterprise.get('prefs').mandatoryTransferDate)
    Dates.getDaysUntil(targetDate)

  renderRemainingDays: ->
    remainingDays = @_remainingDays()
    if remainingDays <= 10
      @$el.addClass('mod-warning')
    else
      @$el.addClass('mod-info')

    if 1 < remainingDays <= 5
      @$el.addClass('mod-medium-urgent')
    else if remainingDays <= 1
      @$el.addClass('mod-urgent')

    @$el.html(
      template(
        targetDate: Dates.toDateString(@enterprise.get('prefs').mandatoryTransferDate),
        enterpriseDisplayName: @enterprise.get('displayName')
      )
    )

  render: ->
    if !@model.isDismissed(BANNER_MESSAGE_NAME) && @enterprise?
      @renderRemainingDays()
    @



// WEBPACK FOOTER //
// ./app/scripts/views/header/account-transfer-required-banner-view.coffee